import { useEffect, useState } from 'react';
import SigmaDeviceManager from '@socure-inc/device-risk-sdk';
import { useHttpQueryWithLoading } from 'packages/http-client/react';
import { createGetConfigurationRequest } from 'apps/acp/packages/webapi';

export const SESSION_STORAGE_KEY = 'effectiv_session_token';
const PROVIDER = 'SOCURE';

export const getProvider = (): string => PROVIDER;

const setToken = (value: string) => {
  // eslint-disable-next-line no-console
  console.info('Digital Intelligence: setToken called');
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, value);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Digital Intelligence: sessionStorage write failed', e);
  }
  try {
    localStorage.setItem(SESSION_STORAGE_KEY, value);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Digital Intelligence: localStorage write failed', e);
  }
};

export const getSessionToken = (): string => {
  // eslint-disable-next-line no-console
  console.info('Digital Intelligence: getSessionToken called');
  return (
    sessionStorage.getItem(SESSION_STORAGE_KEY) ||
    localStorage.getItem(SESSION_STORAGE_KEY) ||
    'FAILED TO OBTAIN FINGERPRINT: Digital Intelligence Socure SDK not initialized'
  );
};

const initSDK = async (sdkKey: string) => {
  // eslint-disable-next-line no-console
  console.info('Digital Intelligence: initSDK called');
  const existingToken = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (existingToken && !existingToken.startsWith('FAILED TO OBTAIN')) {
    return;
  }

  SigmaDeviceManager.initialize({ sdkKey });

  const token = await SigmaDeviceManager.getSessionToken();

  if (token) {
    setToken(token);
  } else {
    setToken(
      'FAILED TO OBTAIN FINGERPRINT: SDK initilized but token not available.'
    );
  }
};

export const useDigitalIntelligenceSdk = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  const [loading, config] = useHttpQueryWithLoading(
    createGetConfigurationRequest()
  );

  const digitalIntelligenceSdkKey = config?.['digital.intelligence.sdk.key'];

  useEffect(() => {
    if (loading || isInitialized) return;

    const init = async () => {
      if (digitalIntelligenceSdkKey) {
        try {
          await initSDK(digitalIntelligenceSdkKey);
        } catch (err) {
          setToken(`FAILED TO OBTAIN FINGERPRINT: Init SDK - ${String(err)}`);
        } finally {
          setIsInitialized(true);
        }
      } else {
        setToken('FAILED TO OBTAIN FINGERPRINT: SDK key not available');
        setIsInitialized(true);
      }
    };

    init();
  }, [loading, digitalIntelligenceSdkKey, isInitialized]);

  return isInitialized;
};

export const useDigitalIntelligenceSdkNoConfig = ({
  digitalIntelligenceSdkKey
}: {
  digitalIntelligenceSdkKey?: string;
}) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isInitialized) return;

    const init = async () => {
      if (digitalIntelligenceSdkKey) {
        try {
          await initSDK(digitalIntelligenceSdkKey);
        } catch (err) {
          setToken(`FAILED TO OBTAIN FINGERPRINT: Init SDK - ${String(err)}`);
        } finally {
          setIsInitialized(true);
        }
      } else {
        setToken('FAILED TO OBTAIN FINGERPRINT: SDK key not available');
        setIsInitialized(true);
      }
    };

    init();
  }, [digitalIntelligenceSdkKey, isInitialized]);

  return isInitialized;
};
